export default __webpack_public_path__ + "static/media/6.8bde6bf9.jpg";